import React, {useState, useEffect, useRef} from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import g_logo from '../assets/img/g_logo.png';
import { useLanguage } from '../hooks/useLanguage';

function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const { currentLanguage, changeLanguage } = useLanguage();
    const [isHovering, setIsHovering] = useState(false);
    const hoverTimeoutRef = useRef(null);
    const menuData = [
      {
        label: { ko: 'Solutions', en: 'Solutions' },
        url: '/solutions/aceTrader',
        submenu: [
          { label: { ko: 'ACE Trader', en: 'ACE Trader' }, url: '/solutions/aceTrader' },
          { label: { ko: 'ACE eXchange', en: 'ACE eXchange' }, url: '/solutions/aceExchange' },
          { label: { ko: 'ACE ADLIB', en: 'ACE ADLIB' }, url: '/solutions/adlib' },
        ],
      },
      {
        label: { ko: 'Resources', en: 'Resources' },
        url: '/resources/notice',
        submenu: [
          { label: { ko: 'Notice', en: 'Notice' }, url: '/resources/notice' },
          { label: { ko: 'FAQ', en: 'FAQ' }, url: '/resources/faq' },
          { label: { ko: '자료실', en: 'Downloads' }, url: '/resources/data' },
          { label: { ko: 'Blog', en: 'Blog' }, url: '/resources/blog' },
        ],
      },
      {
        label: { ko: 'Company', en: 'Company' },
        url: '/company/about',
        submenu: [
          { label: { ko: '회사소개', en: 'About Us' }, url: '/company/about' },
          { label: { ko: '오시는길', en: 'Location' }, url: '/company/location' },
          { label: { ko: '채용', en: 'Careers' }, url: 'https://careers.nhn.com/' },
        ],
      },
    ];
    

    const handleMouseEnter = () => {
      clearTimeout(hoverTimeoutRef.current);
      setIsHovering(true);
    };
  
    const handleMouseLeave = () => {
      hoverTimeoutRef.current = setTimeout(() => {
        setIsHovering(false);
      }, 200);
    };

    // 언어 변경 핸들러 추가
    const handleLanguageChange = (language) => {
      changeLanguage(language);
    };
  
    // 모바일 메뉴
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // 모바일 메뉴 오픈
    const [openMobileMenuIdx, setOpenMobileMenuIdx] = useState(null); // 모바일 메뉴 슬라이드다운

    // resize 이벤트 감지
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 1200);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    // 모바일사이즈일때
    useEffect(() => {
      if (isMobile) {
        if (isMobileMenuOpen) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
    
        return () => {
          document.body.style.overflow = '';
        };
      }
    }, [isMobileMenuOpen, isMobile]);
    
    // 모바일 메뉴 토글 핸들러
    const handleMobileMenuToggle = (idx) => {
      setOpenMobileMenuIdx(prev => prev === idx ? null : idx);
    };

    //다국어 셀렉박스
    const [langOpen, setLangOpen] = useState(false);
    const langRef = useRef(null);

    // 바깥 클릭 시 드롭다운 닫기
    useEffect(() => {
      function handleClickOutside(event) {
        if (langRef.current && !langRef.current.contains(event.target)) {
          setLangOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    return (
        <header>
          <div
            className={`header_wrap ${isHovering ? 'menu_active' : ''}`}
          >
            <div className='header_inner'>
              <h1 className='g_logo'>
                <a 
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    if (location.pathname !== '/') {
                      navigate('/');
                    } else {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
                >
                  <img src={g_logo} alt="g_logo"/>
                </a>
              </h1>


              {isMobile && isMobileMenuOpen ? (
                // 모바일 메뉴
                <nav className='mo_menu'>
                  <div className='mo_top'>
                    <i 
                      className='close'
                      onClick={() => {
                        setIsMobileMenuOpen(false)
                        setOpenMobileMenuIdx(null); // 모든 서브메뉴 닫기
                      }}  
                    ></i>
                  </div>
                  <ul>
                    {menuData
                      .filter(menu => !(currentLanguage === 'en' && menu.label.en === 'Resources'))
                      .map((menu, idx) => (
                        <li key={idx}>
                          <div
                            className="mo_menu_title"
                            onClick={() => handleMobileMenuToggle(idx)}
                          >
                            {menu.label[currentLanguage]}
                          </div>
                          <ul
                            className={`mo_sub_menu ${openMobileMenuIdx === idx ? 'open' : ''}`}
                          >
                            {menu.submenu.map((sub, sIdx) => (
                              <li key={sIdx}>
                                <a 
                                  href={sub.url}
                                  onClick={(e) => {
                                    if (sub.url === 'https://careers.nhn.com/') {
                                      e.preventDefault(); // 기본 동작 막기 먼저!
                                      window.open(sub.url, '_blank');
                                    } else {
                                      e.preventDefault();
                                      window.location.href = sub.url;
                                    }
                                  }}
                                >
                                  {sub.label[currentLanguage]}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                  </ul>
                  <div className='mo_lang'>
                    <span
                      className={currentLanguage === 'ko' ? 'active' : ''}
                      onClick={() => handleLanguageChange('ko')}
                      style={{ cursor: 'pointer' }}
                    >
                      KOR
                    </span>
                    <span
                      className={currentLanguage === 'en' ? 'active' : ''}
                      onClick={() => handleLanguageChange('en')}
                      style={{ cursor: 'pointer' }}
                    >
                      ENG
                    </span>
                  </div>
                </nav>
              ): !isMobile ? (
                // pc 메뉴
                <nav 
                  className='menu'
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <ul>
                    {menuData
                      .filter(menu => !(currentLanguage === 'en' && menu.label.en === 'Resources'))
                      .map((menu, idx) => (
                        <li key={idx}>
                          <Link to={menu.url}>{menu.label[currentLanguage]}</Link>
                          <ul className="sub_menu">
                            {menu.submenu.map((sub, sIdx) => (
                              <li key={sIdx}>
                                <a 
                                  href={sub.url}
onClick={(e) => {
  if (sub.url === 'https://careers.nhn.com/') {
    e.preventDefault(); // 기본 동작 막기 먼저!
    window.open(sub.url, '_blank');
  } else {
    e.preventDefault();
    window.location.href = sub.url;
  }
}}
                                >
                                  {sub.label[currentLanguage]}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                  </ul>
                </nav>
              ) : null }
              <div className='g_right_box'>
                <div className='lang_dropdown' ref={langRef}>
                  <div
                    className='lang_selected'
                    onClick={() => setLangOpen((prev) => !prev)}
                  >
                    {currentLanguage === 'ko' ? 'KOR' : 'ENG'}
                    <span className={`arrow ${langOpen ? "up" : "down"}`}></span>
                  </div>
                  {langOpen && (
                    <ul className='lang_options'>
                      <li
                        className={currentLanguage === 'ko' ? 'active' : ''}
                        onClick={() => { handleLanguageChange('ko'); setLangOpen(false); }}
                      >
                        KOR
                        <i></i>
                      </li>
                      <li
                        className={currentLanguage === 'en' ? 'active' : ''}
                        onClick={() => { handleLanguageChange('en'); setLangOpen(false); }}
                      >
                        ENG
                        <i></i>
                      </li>
                    </ul>
                  )}
                </div>
                <button 
                  className='ham'
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  onClick={() => {
                    if (isMobile) setIsMobileMenuOpen(true)}}
                ></button>
              </div>

            </div>
            {!isMobile && 
              <div className={`sub_bg ${isHovering ? 'menu_active' :''}`} ></div>
            }
                      
          </div>
        </header>
    );
}

export default Header;